export default __webpack_public_path__ + "static/media/PersImg11.50d984c2.jpg";